import { createFileRoute, redirect } from "@tanstack/react-router";
// No matching blog category. Redirect to the Foam Roof Coating/Recoating service page.
export const Route = createFileRoute("/category/foam-roof-coating")({
  beforeLoad: () => { throw redirect({ to: "/foam-roof-coating-recoating", statusCode: 301 }); },
});
